import { render, staticRenderFns } from "./BlacklistedPhonesManage.vue?vue&type=template&id=26bae7fc&scoped=true&"
import script from "./BlacklistedPhonesManage.vue?vue&type=script&lang=js&"
export * from "./BlacklistedPhonesManage.vue?vue&type=script&lang=js&"
import style0 from "./BlacklistedPhonesManage.vue?vue&type=style&index=0&id=26bae7fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26bae7fc",
  null
  
)

component.options.__file = "BlacklistedPhonesManage.vue"
export default component.exports